import { createStore } from 'vuex';
import survey from './modules/survey';
import review from './modules/review';
import main from './modules/main-store';
import payments from './modules/payments'
import quiz from './modules/quiz-store';
import popups from "@/store/modules/popups-store";
import paymentsStore from "@/store/modules/payments-store";
// import trackerVuex from '@openreplay/tracker-vuex'

// const plugin = (tracker) => {
//     return (store) => {
//         const vuexPlugin = tracker.use(trackerVuex(<options></options>))
//         const storeTracker = vuexPlugin('Store')
//         return storeTracker
//     }
// }

const store = (tracker) => {
    return createStore({
        // plugins: [plugin(tracker)],
        modules: {
            survey,
            review,
            main,
            payments,
            quiz,
            paymentsStore,
            popups
        },
    });
}
export default store;
